// import React from "react";
// import styles from "./ProductButtons.module.css";
// import { useNavigate } from "react-router-dom";

// function ProductButtons() {
//   const navigate = useNavigate();

//   return (
//     <div className={styles.container}>

      
//       <button className={`${styles.productButton} ${styles.left}`} onClick={() => navigate("/products/juise")}>
//         <img src="/assets/products/juice/juise_001.png" alt="Juise" />
//       </button>

//       <button className={`${styles.productButton} ${styles.centerLower}`} onClick={() => navigate("/products/pineapple")}>
//         <img src="/assets/pineapple.png" alt="Pineapple" />
//       </button>

//       <button className={`${styles.productButton} ${styles.center}`} onClick={() => navigate("/products/canned")}>
//         {/* <img src="/assets/cans.png" alt="Canned Fish" /> */}
//         <img src="/assets/products/canned/can_main_product_12.png" alt="Canned Fish" />
//         {/* <img src="/assets/tuna.png" alt="Tuna" /> */}
//       </button>

//       <button className={`${styles.productButton} ${styles.centerLower}`} onClick={() => navigate("/products/olive")}>
//         <img src="/assets/olive.png" alt="Olives" />
//       </button>

//       <button className={`${styles.productButton} ${styles.right}`} onClick={() => navigate("/products/tuna")}>
//         <img src="/assets/tuna_001.png" alt="Tuna" />
//       </button>
//     </div>
//   );
// }

// export default ProductButtons;


import React from "react";
import styles from "./ProductButtons.module.css";
import { useNavigate } from "react-router-dom";

function ProductButtons() {
  const navigate = useNavigate();

  return (
    <div className={styles.carouselWrapper}>
      <div className={styles.container}>
        <button className={`${styles.productButton} ${styles.left}`} onClick={() => navigate("/products/juise")}>
          <img src="/assets/products/juice/juise_001.png" alt="Juise" />
        </button>

        <button className={`${styles.productButton} ${styles.centerLower}`} onClick={() => navigate("/products/pineapple")}>
          <img src="/assets/pineapple.png" alt="Pineapple" />
        </button>

        <button className={`${styles.productButton} ${styles.center}`} onClick={() => navigate("/products/canned")}>
          <img src="/assets/products/canned/can_main_product_12.png" alt="Canned Fish" />
        </button>

        <button className={`${styles.productButton} ${styles.centerLower}`} onClick={() => navigate("/products/olive")}>
          <img src="/assets/olive.png" alt="Olives" />
        </button>

        <button className={`${styles.productButton} ${styles.right}`} onClick={() => navigate("/products/tuna")}>
          <img src="/assets/tuna_001.png" alt="Tuna" />
        </button>
      </div>
    </div>
  );
}

 export default ProductButtons;